import { NgModule } from '@angular/core';

import { ResourceService } from './resource.service';
import { HttpClientModule } from '@angular/common/http';
import { InstanceModule } from '../instance/instance.module';
import { ErrorTracingModule } from '../error-tracing/error-tracing.module';
import { AuthRedirectModule } from "libraries/service/auth-redirect/auth-redirect.module";


@NgModule({
    imports: [
        HttpClientModule,
        InstanceModule,
        ErrorTracingModule,
        AuthRedirectModule,
    ],
    providers: [
        ResourceService
    ]
})
export class ResourceModule { }
